// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Mixins
import {EventBus} from '../../../mixins/event_bus/EventBus'

// Components
import {Button} from '../button/Button'
import {Tooltip} from '../tooltip/Tooltip'

@Component({
    name: 'InputGroup',
    components: {
        Button,
        Tooltip,
    },
    mixins: [
        template,
    ]
})
export class InputGroup extends mixins(EventBus) {

    public get inputGroupThemeClass() {

        if ( this.isMobile || this.isVertical )
        {
            return `${this.$appPrefix}-input-group--vertical`;
        }
        if ( this.isTablet )
        {
            return `${this.$appPrefix}-input-group--horizontal-small`;
        }
        return `${this.$appPrefix}-input-group--horizontal`

    }

    public get isVertical()
    {
        return this.theme == 'vertical';
    }

    public isMobile: boolean = false
    public isTablet: boolean = false

    public isFormTourCurrentStep: boolean = false

    @Prop({default: 'horizontal'})
    public theme!: string

    @Prop({default: false})
    public forceInfoIcon!: boolean

    @Prop()
    public tooltipWidth!: string

    @Prop({default: false})
    public isTextContent!: boolean

    @Prop({ default: true })
    public hasFormTourPoint!: boolean

    @Prop()
    public isTourCurrentStep!: boolean

    public created() {
        window.addEventListener('resize', this.handleResize)
        this.$on('isFormTourCurrentStep', this.handleIsFormTourCurrentStepChange)
    }

    public mounted () {
        this.setDeviseType()
    }

    public destroyed() {
        window.removeEventListener('resize', this.handleResize)
        this.$off('isFormTourCurrentStep', this.handleIsFormTourCurrentStepChange)
    }

    public handleResize(e: Event) {

        this.setDeviseType()
    }

    public setDeviseType() {

        const width = window.innerWidth
            || (<any>document).documentElement.clientWidth
            || (<any>document).body.clientWidth

        if (width < 768) {
            this.isTablet = false
            this.isMobile = true
        } else if (768 <= width && width < 992) {
            this.isTablet = true
            this.isMobile = false
        } else {
            this.isTablet = false
            this.isMobile = false
        }
    }

    public handleIsFormTourCurrentStepChange(isFormTourCurrentStep: boolean) {
        this.isFormTourCurrentStep = isFormTourCurrentStep
        this.$emit('update:isTourCurrentStep', isFormTourCurrentStep)
    }
}